<template>
  <b-container class="py-4">
    <b-row>
      <b-col>
        <FCPLogsTable :fitTableBodyToWindow="true" />
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { defineComponent } from "@vue/composition-api";

import store from "@store";

import FCPLogsTable from "@components/FCP/FCPLogsTable";

export default defineComponent({
  name: "FCPLogs",
  components: {
    FCPLogsTable,
  },
  beforeRouteEnter(to, from, next) {
    if (!store.getters.hasFCPAccess) next({ name: "Home" });

    next();
  },
});
</script>
